import { observer } from "mobx-react-lite";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { TimeProvider } from "utils";

import { useAuthStore } from "src/auth";

// Reads viewer TZ from auth context and feeds it to <TimeProvider>. Falls back
// to device TZ when no user is logged in or Settings.timezone is unset.
//
// Locale comes from `useTranslation()` so language switches re-render — reading
// `i18next.language` directly off the singleton would not subscribe React to
// changes and the calendar would render with the previous locale until refresh.
export const TimeProviderWithAuth = observer(function TimeProviderWithAuth(
  props: React.PropsWithChildren,
) {
  const authStore = useAuthStore();
  const { i18n } = useTranslation();
  return (
    <TimeProvider
      viewerTz={authStore.maybeUser ? authStore.viewerTimezone : null}
      locale={i18n.language}
    >
      {props.children}
    </TimeProvider>
  );
});
